import { API_BASE } from '@/utils/api-url'

export async function getCurrentUserInfo() {
  const token = localStorage.getItem('dzzj_website_token')
  const response = await fetch(`${API_BASE}/user/info`, {
    headers: token ? { Authorization: `Bearer ${token}` } : {}
  })
  const result = await response.json()
  if (response.status === 424 || result.code === 424) {
    if (token) {
      localStorage.removeItem('dzzj_website_token')
      localStorage.removeItem('dzzj_website_refresh_token')
      window.dispatchEvent(new CustomEvent('website-auth-expired'))
    }
    throw new Error('登录已失效，请重新登录')
  }
  if (!response.ok || result.code !== 0) {
    throw new Error(result.msg || '账号资料加载失败')
  }
  return result.data
}
